import { render, staticRenderFns } from "./compose-message.vue?vue&type=template&id=7bab64b5&scoped=true&"
import script from "./compose-message.vue?vue&type=script&lang=js&"
export * from "./compose-message.vue?vue&type=script&lang=js&"
import style0 from "./compose-message.vue?vue&type=style&index=0&id=7bab64b5&lang=scss&scoped=true&"
import style1 from "./compose-message.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bab64b5",
  null
  
)

component.options.__file = "compose-message.vue"
export default component.exports